import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { ApiRoutes } from '../services/api/api-routes.consts';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  public constructor(private authService: AuthService) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!ApiRoutes.isApiAuthorizationNeeded(req.url)) {
      return next.handle(req);
    }
    return this.authService.acquireIdToken().pipe(
      mergeMap((idToken: string) => {
        const requestClone = req.clone({ headers: req.headers.set('X-Nimb-Auth', `Bearer ${idToken}`) });
        return next.handle(requestClone);
      }),
    );
  }
}
